import { render, staticRenderFns } from "./bafter.vue?vue&type=template&id=61129e0f&scoped=true&"
import script from "./bafter.vue?vue&type=script&lang=js&"
export * from "./bafter.vue?vue&type=script&lang=js&"
import style0 from "./bafter.vue?vue&type=style&index=0&id=61129e0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61129e0f",
  null
  
)

export default component.exports